import React from 'react';

export type Props = {
  className?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};
export const FacebookCircle = React.memo((props: Props) => {
  return (
    <svg
      width={props.width || 40}
      height={props.height || 40}
      className={props.className}
      onClick={props.onClick}
      viewBox='0 0 40 40'
    >
      <g fill='none'>
        <rect width='40' height='40' rx='20' fill='white'/>
        <path d='M32 20.073C32 13.446 26.627 8.073 20 8.073C13.373 8.073 8 13.446 8 20.073C8 26.063 12.388 31.027 18.125 31.927V23.542H15.078V20.072H18.125V17.43C18.125 14.423 19.917 12.761 22.658 12.761C23.97 12.761 25.344 12.996 25.344 12.996V15.949H23.83C22.339 15.949 21.874 16.874 21.874 17.823V20.073H25.202L24.67 23.543H21.874V31.928C27.612 31.027 32 26.062 32 20.073Z' fill='var(--footer-social-icons-color)'/>
      </g>
    </svg>
  );
});

FacebookCircle.displayName = 'FacebookCircle';
